import React from 'react'

import { TransportIcon, LabelMapping } from '../../utils/IconMapping'
import { RouteTo } from '../../utils/Navigationstack'
import { slide } from '../../transitions'
import { DatabaseInterface, Table, DatabaseInfo } from '../../utils/Database/DatabaseInterface'

export default class EditableFavoritesItem extends DatabaseInterface {
  render() {
    const { station } = this.props;
    const name = station.name.includes(',') ? station.name.split(',')[1] : station.name
    const labelText = station.name.split(',')[0]

    return (
      <li className='favorites-editable'>
        <a onClick={() => this.handleClick()}>
          <span className='left-block'>
            <span className='nearStationName'>{name}</span>
            <br />
            <LabelMapping station={station} labelText={labelText} />
          </span>
          <span className='right-block'>
            <TransportIcon station={station} />
          </span>
        </a>
        <span className={this.props.layoutState === null ? '' : (this.props.layoutState ? 'delete-favorite grow-in' : 'delete-favorite grow-out')} onClick={this.removeFromFavorites} />
      </li>
    )
  }

  handleClick() {
    RouteTo(this.context.router.history, '/station/' + this.props.station.station_id + '/' + this.props.station.products, slide, false, this.props.station)
  }

  removeFromFavorites = () => {
    var sql = 'UPDATE ' + Table.stationsTable + ' SET favorite=? WHERE id=' + this.props.station.id

    const lCondition = { column: 'station_id', value: this.props.station.station_id };
    const lUpdateData = { column: 'favorite', value: false };

    (DatabaseInfo.type === 'WebSQL' && this.update(Table.stationsTable, sql, [false])) || this.update(Table.stationsTable, lCondition, lUpdateData, this.props.station)

    this.props.fetchFavorites()
  }
}
